// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import appStore from '../../../../images/app-store-image.png';
import google from '../../../../images/google-play-image.png';

import styles from './styles';

const DownloadIcon = ({ classes, isIndex }) => {
  // eslint-disable-next-line max-len
  const appStoreLink = 'https://apps.apple.com/us/app/sell-it-back-cash-for-books/id1474080128?ls=1';
  const googlePlayLink = 'https://play.google.com/store/apps/details?id=com.sellitback';

  return (
    <div className={classes.imageContainer}>
      <base target={'_blank'} />
      <a href={appStoreLink}>
        <img
          className={isIndex ? classes.image : classes.smallImage}
          src={appStore}
          alt={'apple'}
        />
      </a>
      <a href={googlePlayLink}>
        <img
          className={isIndex ? classes.image : classes.smallImage}
          src={google}
          alt={'google'}
        />
      </a>
    </div>
  );
};

DownloadIcon.propTypes = {
  classes: PropTypes.object,
  isIndex: PropTypes.bool,
};

DownloadIcon.defaultProps = {
  classes: {},
  isIndex: false,
};

export default withStyles(styles)(DownloadIcon);
